import { render, staticRenderFns } from "./QuizListWrapper.vue?vue&type=template&id=137520c7"
import script from "./QuizListWrapper.vue?vue&type=script&lang=js"
export * from "./QuizListWrapper.vue?vue&type=script&lang=js"
import style0 from "./QuizListWrapper.vue?vue&type=style&index=0&id=137520c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports